import { ContentType } from "graphql/schemas/action/Action"
import intl from 'react-intl-universal'

export const contentTypes: Record<ContentType, string> = {
  multiple_choice: "Multiple Choice",
  qa: "QA",
  photo: "Photo",
  image: "Image",
  audio: "Audio",
  video: "Video",
  text: "Text",
  quote: "Quote",
  certificate: "Certificate",
  // assessment: "Assessment",
  upload: "Upload",
  // rating: "Rating",
  word_puzzle: "Word Puzzle"
}

export const useCases = {
  get training() { return intl.get('gnowbe_ai_use_case_training') },
  get onboarding() { return intl.get('gnowbe_ai_use_case_onboarding') },
  get alignment() { return intl.get('gnowbe_ai_use_case_alignment') },
  get sales_enablement() { return intl.get('gnowbe_ai_use_case_sales_enablement') },
  get leadership_development() { return intl.get('gnowbe_ai_use_case_leadership_development') },
  get operations() { return intl.get('gnowbe_ai_use_case_operations') },
  get safety_and_compliance() { return intl.get('gnowbe_ai_use_case_safety_and_compliance') },
  get partner_engagement() { return intl.get('gnowbe_ai_use_case_partner_engagement') },
  get customer_engagement() { return intl.get('gnowbe_ai_use_case_customer_engagement') },
  get technical_skills() { return intl.get('gnowbe_ai_use_case_technical_skills') },
}

export const languages = {
  ar: "Arabic",
  bn: "Bengali",
  bg: "Bulgarian",
  zh: "Chinese",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  nl: "Dutch",
  en: "English",
  et: "Estonian",
  fi: "Finnish",
  fr: "French",
  ka: "Georgian",
  de: "German",
  el: "Greek",
  iw: "Hebrew",
  hi: "Hindi",
  hu: "Hungarian",
  id: "Indonesian",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  lv: "Latvian",
  lt: "Lithuanian",
  no: "Norwegian",
  pl: "Polish",
  pt: "Portuguese",
  ro: "Romanian",
  ru: "Russian",
  sr: "Serbian",
  sk: "Slovak",
  sl: "Slovenian",
  es: "Spanish",
  sw: "Swahili",
  sv: "Swedish",
  th: "Thai",
  tr: "Turkish",
  uk: "Ukrainian",
  vi: "Vietnamese"
}

export const sessionLength = {
  get 3() { return intl.get('gnowbe_ai_session_length_3') },
  get 6() { return intl.get('gnowbe_ai_session_length_6') },
  get 10() { return intl.get('gnowbe_ai_session_length_10') }
}

export const programLength = {
  get 3() { return intl.get('gnowbe_ai_program_length_3') },
  get 6() { return intl.get('gnowbe_ai_program_length_6') },
  get 10() { return intl.get('gnowbe_ai_program_length_10') },
  get other() { return intl.get('gnowbe_ai_audience_other') }
}

export const voice = {
  get professional() { return intl.get('gnowbe_ai_tone_of_voice_professional') },
  get casual() { return intl.get('gnowbe_ai_tone_of_voice_casual') },
  get inspirational() { return intl.get('gnowbe_ai_tone_of_voice_inspirational') },
  get playful() { return intl.get('gnowbe_ai_tone_of_voice_playful') },
  get educational() { return intl.get('gnowbe_ai_tone_of_voice_educational') },
  get story_driven() { return intl.get('gnowbe_ai_tone_of_voice_story_driven') }
}

export const programDifficulty = {
  get basic() { return intl.get('course_difficulty_basic') },
  get intermediate() { return intl.get('course_difficulty_intermediate') },
  get advanced() { return intl.get('course_difficulty_advanced') },
  get universal() { return intl.get('course_difficulty_universal') }
}

export const audienceOptions = {
  get individual() { return intl.get('gnowbe_ai_audience_individual') },
  get manager() { return intl.get('gnowbe_ai_audience_manager') },
  get senior() { return intl.get('gnowbe_ai_audience_senior') },
  get other() { return intl.get('gnowbe_ai_audience_other') },
}

export const matchTypes = {
  get low_precision() { return intl.get('gnowbe_ai_match_type_low_precision') },
}

export const matchMethodTypes = {
  get full_program() { return intl.get('gnowbe_ai_match_method_full_program') },
  get single_session() { return intl.get('gnowbe_ai_match_method_single_session') },
  // add_as_resource: "Add as resource"
}
